<template>
  <div
    class="position-control"
    :class="[
      (expanded ? 'expanded' : ''),
      (fullscreen ? 'fullscreen' : ''),
    ]"
  >
    <VsSliderTP
      :value="position"
      :max="duration"
      :minimized="!expanded"
      @input="changePosition"

      @touchmove.native="handleMousemove"
      @touchend.native="hoverPosition = 0"
      @mousemove.native="handleMousemove"
      @mouseleave.native="hoverPosition = 0"

      @dragstart="($event) => $emit('dragstart', $event)"
      @dragend="($event) => $emit('dragend', $event)"
    >
      <div
        slot="floater"
        slot-scope="payload"
        class="position-control__hover__floater"
      >
        {{ payload.value | toTimeFormat }}
      </div>
    </VsSliderTP>
  </div>
</template>

<script>
import padStart from 'lodash/padStart';
import { getAnalyticPayload } from '@/scripts/libs/analytic';
import VsSliderTP from './VsSliderTP';

export default {
  components: {
    VsSliderTP,
  },
  filters: {
    toTimeFormat(time) {
      const roundedTime = Math.round(time);
      const numMin = Math.floor(roundedTime / 60).toFixed(0);
      const numSecond = (roundedTime % 60).toFixed(0);
      return `${padStart(numMin, 2, '0')}:${padStart(numSecond, 2, '0')}`;
    },
  },
  props: {
    position: {
      type: Number,
      required: true,
    },
    duration: {
      type: Number,
      required: true,
    },
    bufferPosition: {
      type: Number,
      default: 0,
    },

    fullscreen: {
      type: Boolean,
      default: false,
    },

    expanded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      hoverPosition: 0,
    };
  },
  methods: {
    changePosition(newPosition) {
      this.analytic.send(
        getAnalyticPayload(
          e => e.player['control-bar'].click['seeker-track'],
          {
            value: newPosition - this.position,
          },
        ),
      );
      this.$emit('setPosition', newPosition);
    },

    handleMousemove(event) {
      let offset = event.offsetX;

      if (event.type === 'touchmove') {
        const touch = event.targetTouches[0] || {};
        offset = touch.clientX;
      }
      this.hoverPosition = ((offset || 0) / event.target.offsetWidth) * 100;
    },
  },
};
</script>

<style lang="scss">
$height-expanded: 8px;
$height-minimized: 4px;
$player-animation-duration: 0.1s;

.position-control {
  // height: $height-minimized;
  margin-top: -$height-minimized;

  transition:
    height $player-animation-duration,
    margin $player-animation-duration,
    opacity $player-animation-duration
    ;

  .position-control__hover {
    pointer-events: none;
    border-right: 4px solid rgba(white, 0.8);
    // background: rgba(white, 0.2);
  }
}
.position-control.expanded {
  // height: $height-expanded;
  margin-top: -$height-expanded;
}

// Hide minimized control on fullscreen
.position-control.fullscreen {
  opacity: 0;
}
.position-control.fullscreen.expanded {
  opacity: 1;
}

// Style floater
.position-control__hover__floater {
  $float-width: 60px;
  position: absolute;
  bottom: 100%;
  width: $float-width;
  height: auto;
  transform: translate(-#{$float-width/2}, 0);
  margin-bottom: 16px;
  background: rgba(white, 0.8);
  box-shadow: 1px 1px 1px 0 rgba(black, 0.1);
  border-radius: 24px;
  padding: 4px;
  color: black;
  text-align: center;
}

</style>
